import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config.json";
import LoginModal from './Login';
const TOTAL_SECONDS = 20 * 60; // 20 minutos

const PreviewDownload: React.FC = () => {
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl]   = useState<string>('');
  const [framework, setFramework]     = useState<string>('');
  const [language, setLanguage]       = useState<string>('');
  const [sessionUUID, setSessionUUID] = useState<string>('');
  const [springReady, setSpringReady] = useState<boolean>(false);
  const [countdown, setCountdown]     = useState<number>(0);
  const [checking, setChecking]       = useState<boolean>(false);

  // Estados del iframe
  const [iframeLoaded, setIframeLoaded] = useState<boolean>(false);
  const [iframeError, setIframeError]   = useState<boolean>(false);

  // Timer de veinte minutos
  const [timeLeft, setTimeLeft] = useState<number>(TOTAL_SECONDS);
  const [timerStarted, setTimerStarted] = useState<boolean>(false);

  const serverProxy = config.SERVER_PROXY;

  useEffect(() => {
    const raw = localStorage.getItem('projectConfig');
    if (!raw) return;

    const projectConfig = JSON.parse(raw);
    const { sessionUUID: uuid, language: lang, framework: fw, previewUrl: savedUrl } = projectConfig;

    setFramework(fw   || '');
    setLanguage(lang  || '');
    setSessionUUID(uuid || '');

    if (savedUrl) {
      setPreviewUrl(savedUrl);
      setSpringReady(true);
      // Calcular tiempo restante desde timerStart guardado
      initTimer(projectConfig);
      return;
    }

    if (!uuid || !fw) return;

    let path = '';
    if (fw === 'Angular') {
      path = `outputAngular/${uuid}/dist/frontend-crud/browser/index.html`;
    } else if (fw === 'Vue') {
      path = `outputVue/${uuid}/dist/index.html`;
    } else if (fw === 'React') {
      path = `outputReact/${uuid}/dist/index.html`;
    }

    const url = `${config.server_base}${path}`;
    setPreviewUrl(url);

    if (lang === 'Java') {
      setChecking(true);
      setCountdown(60);
      waitForSpring(uuid, projectConfig);
    } else {
      startTimer(projectConfig);
      setSpringReady(true);
    }
  }, []);

  /**
   * Lee timerStart del projectConfig guardado y calcula cuánto tiempo queda.
   * No arranca el intervalo — solo setea timeLeft y timerStarted.
   */
  const initTimer = (projectConfig: Record<string, unknown>) => {
    const now = Date.now();
    const existingStart = projectConfig.timerStart as number | undefined;

    if (existingStart) {
      const elapsed = Math.floor((now - existingStart) / 1000);
      setTimeLeft(Math.max(0, TOTAL_SECONDS - elapsed));
    } else {
      // No había timerStart aún (caso raro con savedUrl pero sin timerStart)
      const updated = { ...projectConfig, timerStart: now };
      localStorage.setItem('projectConfig', JSON.stringify(updated));
      setTimeLeft(TOTAL_SECONDS);
    }
    setTimerStarted(true);
  };

  /**
   * Primera vez que el timer debe arrancar: guarda timerStart si no existe.
   */
  const startTimer = (projectConfig: Record<string, unknown>) => {
    const now = Date.now();
    const existingStart = projectConfig.timerStart as number | undefined;

    if (existingStart) {
      const elapsed = Math.floor((now - existingStart) / 1000);
      setTimeLeft(Math.max(0, TOTAL_SECONDS - elapsed));
    } else {
      const updated = { ...projectConfig, timerStart: now };
      localStorage.setItem('projectConfig', JSON.stringify(updated));
      setTimeLeft(TOTAL_SECONDS);
    }
    setTimerStarted(true);
  };

  // Countdown Spring Boot visual
  useEffect(() => {
    if (!checking || countdown <= 0) return;
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [checking, countdown]);

  // Timer de 30 minutos
  useEffect(() => {
    if (!timerStarted) return;
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(t => Math.max(0, t - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [timerStarted, timeLeft]);

  const waitForSpring = async (uuid: string, projectConfig: Record<string, unknown>) => {
    const maxAttempts = 24;
    const delay = 5000;
    const checkUrl = `${config.SPRING_API_URL}/${uuid}`;

    for (let i = 0; i < maxAttempts; i++) {
      try {
        const res = await fetch(checkUrl, { method: 'GET' });
        if (res.status !== 502 && res.status !== 503) {
          setSpringReady(true);
          setChecking(false);
          startTimer(projectConfig);
          return;
        }else{
            const res = await fetch(config.RESETSPRING, { method: 'GET' })
        }
      } catch {
        // Sigue esperando
      }
      await new Promise(r => setTimeout(r, delay));
      setCountdown(c => Math.max(0, c - 5));
    }

    setSpringReady(true);
    setChecking(false);
    startTimer(projectConfig);
  };

  const handleIframeLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    try {
      const doc = (e.target as HTMLIFrameElement).contentDocument;
      if (!doc || doc.title === '404' || doc.body?.innerHTML?.trim() === '') {
        setIframeError(true);
        return;
      }
      const bodyText = doc.body?.innerText?.trim() ?? '';
      if (bodyText.startsWith('{"success":false') || bodyText.startsWith('{"error"')) {
        setIframeError(true);
        return;
      }
      setIframeLoaded(true);
    } catch {
      setIframeLoaded(true);
    }
  };

  const handleRetry = () => {
    setIframeError(false);
    setIframeLoaded(false);
    setPreviewUrl(prev => {
      const base = prev.split('&_t=')[0];
      return `${base}&_t=${Date.now()}`;
    });
  };

  const handleDownload = async () => {
    try {
       const storedUser = localStorage.getItem("user");
        let email="";
        if (storedUser && storedUser !== "undefined") {
         const parsedUser = JSON.parse(storedUser);
         email=parsedUser.email
      }
     // email="TESTUSER8037133266471418896@testuser.com";


      if(email!==""){


     JSON.stringify({ sessionUUID, language, framework, email})
          window.location.href =`${config.ENDPOINTS.CREAR_PREFERENCIA}?email=${encodeURIComponent(email)}&uuid=${encodeURIComponent(sessionUUID)}&lng=${encodeURIComponent(language)}&fr=${encodeURIComponent(framework)}` ;
      }else{
        // alert("debe iniciar session primero");
          const modalElement = document.getElementById('loginModal');
          if (modalElement) {
            const modal = new (window as any).bootstrap.Modal(modalElement);
            modal.show();
          }
      }
    } catch (error) {
     console.error(error);
      alert("Error al conectar con Mercado Pago");
    }
  };

  // Formatear tiempo
  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;
  const timeStr = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

  const pct = (timeLeft / TOTAL_SECONDS) * 100;

  const isUrgent   = timeLeft <= 5 * 60;
  const isCritical = timeLeft <= 2 * 60;

  const timerColor = isCritical ? '#ef4444' : isUrgent ? '#f97316' : '#10b981';

  const barColor = isCritical
    ? 'linear-gradient(90deg, #ef4444, #dc2626)'
    : isUrgent
    ? 'linear-gradient(90deg, #f97316, #ea580c)'
    : 'linear-gradient(90deg, #10b981, #059669)';

  const showIframe = !checking && !!previewUrl && springReady && !iframeError && timeLeft > 0;

      
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>

      {/* HEADER */}
      <header style={{
        backgroundColor: "#0f172a",
        color: "white",
        flexShrink: 0,
        boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
      }}>
        <div style={{
          height: "56px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
        }}>
          <h3 style={{ margin: 0, fontSize: "15px", fontWeight: 600, color: "#e2e8f0", letterSpacing: "0.01em" }}>
            Proyecto Generado {framework ? <span style={{ color: "#38bdf8" }}>— {framework}</span> : ''}
          </h3>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

            {/* Timer badge */}
            {timerStarted && timeLeft > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(255,255,255,0.05)",
                border: `1px solid ${timerColor}40`,
                borderRadius: "8px",
                padding: "5px 12px",
                animation: isCritical ? "pulse-border 1s ease-in-out infinite" : "none",
              }}>
                <span style={{ fontSize: "16px" }}>⏱</span>
                <div>
                  <div style={{ fontSize: "11px", color: "#94a3b8", lineHeight: 1 }}>tu proyecto expira en</div>
                  <div style={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: timerColor,
                    fontFamily: "monospace",
                    lineHeight: 1.2,
                    transition: "color 0.5s",
                  }}>
                    {timeStr}
                  </div>
                </div>
              </div>
            )}

            {/* Expirado */}
            {timerStarted && timeLeft === 0 && (
              <div style={{
                background: "#7f1d1d",
                border: "1px solid #ef444460",
                borderRadius: "8px",
                padding: "5px 12px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#fca5a5",
              }}>
                ⚠️ Proyecto expirado
              </div>
            )}

            <button
              style={{ backgroundColor: "#334155", color: "#cbd5e1", border: "none", padding: "7px 14px", borderRadius: "6px", cursor: "pointer", fontSize: "13px" }}
              onClick={() => navigate("/")}
            >
              Inicio
            </button>
            <button
              style={{
                background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
                color: "white", border: "none", padding: "7px 16px",
                borderRadius: "6px", cursor: "pointer", fontSize: "13px",
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(37,99,235,0.4)",
              }}
              onClick={handleDownload}
            >
              ⬇ Descargar
            </button>
          </div>
        </div>

        {/* Barra de progreso de tiempo */}
        {timerStarted && (
          <div style={{ height: "3px", background: "#1e293b", position: "relative" }}>
            <div style={{
              height: "100%",
              width: `${pct}%`,
              background: barColor,
              transition: "width 1s linear, background 1s ease",
              borderRadius: "0 2px 2px 0",
            }} />
          </div>
        )}
      </header>

      {/* BANNER urgencia */}
      {timerStarted && isUrgent && timeLeft > 0 && (
        <div style={{
          background: isCritical
            ? "linear-gradient(135deg, #7f1d1d, #991b1b)"
            : "linear-gradient(135deg, #431407, #7c2d12)",
          borderBottom: `1px solid ${timerColor}50`,
          padding: "8px 20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexShrink: 0,
          animation: "slideDown 0.3s ease",
        }}>
          <span style={{ fontSize: "18px" }}>{isCritical ? "🚨" : "⚠️"}</span>
          <span style={{ fontSize: "13px", color: isCritical ? "#fca5a5" : "#fdba74", fontWeight: 500 }}>
            {isCritical
              ? `¡Solo quedan ${timeStr}! Tu proyecto será eliminado muy pronto. Descárgalo ahora.`
              : `Tu proyecto expira en ${timeStr}. Descárgalo antes de que sea eliminado del servidor.`
            }
          </span>
          <button
            onClick={handleDownload}
            style={{
              marginLeft: "auto",
              background: timerColor,
              color: "white",
              border: "none",
              padding: "5px 14px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "12px",
              flexShrink: 0,
            }}
          >
            Descargar ahora
          </button>
        </div>
      )}

   

   
   

      
   
        <iframe
          key={previewUrl}
          src={previewUrl}
         
          style={{
            flex: 1,
            border: "none",
            width: "100%",
            height: "100%",
            
          }}
          title="Preview del proyecto"
        />
       <LoginModal />

      {/* Sin configuración */}
      {!checking && !previewUrl && (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "#6b7280" }}>
          No se encontró configuración del proyecto.
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes pulse-border {
          0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.4); }
          50%       { box-shadow: 0 0 0 6px rgba(239,68,68,0); }
        }
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
          header{
              height: 10vh;
          }
          iframe{
             height: 90vh;
          }
      `}</style>
    </div>
  );
};

export default PreviewDownload;